import styled from 'styled-components'
import Group from 'components/utils/Group'

const ListingDrawerTitleGroup = styled(Group)`
  flex: 1;
  min-width: 0;
`

export default ListingDrawerTitleGroup
